import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
      <div className="text-center">
        {/* Logo */}
        <img 
          src="https://customer-assets.emergentagent.com/job_abudhabi-heavygear/artifacts/ehlf0vwr_finallogo.png"
          alt="Sialkot Gold Transport"
          className="h-20 w-auto mx-auto mb-6 animate-pulse"
        />
        
        {/* Loading spinner */}
        <div className="flex items-center justify-center space-x-2">
          <div className="w-3 h-3 bg-gold rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-3 h-3 bg-gold rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-3 h-3 bg-gold rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
        
        <p className="text-gray-400 mt-4 text-sm">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
